<template lang="pug">
.wrap
  page-title
    | Your Dashboard

  p
    | Each app has a number of seats which determines how many users you can add. If you'd like to enquire about upgrading, please
    | contact us here.


  .apps(v-loading='loading')
    .app(v-for='license in appLicenses' :key='license.id')
      
      .app-name {{ license.app.name }}
      .app-remaining-seats {{ license.numOfLicenseSeats - license.numUsers }}
      .app-tot-seats of {{ license.numOfLicenseSeats }} seats remaining
      .app-action
        router-link(slot='action' :to="{ name: 'companyAdmin:users' }")
          el-button(type="primary") Manage seats

</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";

export default {
  components: { PageTitle },
  data() {
    return {
      appLicenses: [],
      loading: false
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      fetchAppLicenses: "appLicenses/fetchAppLicenses"
    }),
    fetchData() {
      this.fetchAppLicenses().then(data => {
        this.appLicenses = data;
        this.loading = false;
      });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/mixins.scss";
.apps {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  width: 100%;

  // min-height: 300px;
  .app {
    flex-basis: 300px;
    max-width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 10px;
    border: 1px solid #ddd;
    background: white;
    padding: 20px 10px;
  }
  @include MQ(M) {
    flex-direction: column;
    max-height: auto;
    margin-top: 0px;
    .app {
      max-width: 100%;
      width: 100%;
      margin: 10px 0;
    }
  }
}

.app-header {
  background: white;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-action {
  margin-top: 20px;
}

.app-name {
  font-size: 24px;
  font-family: "gilroyextrabold";
  letter-spacing: 0.05em;
}

.app-remaining-seats {
  font-size: 45px;
  margin: 10px 0;
}
</style>
